export enum AGENT_ACTIVITY_ACTIONS {
    START_SCENE_BUILDING = 'START_SCENE_BUILDING',
    RECORD_SCENE_FILL = 'RECORD_SCENE_FILL',
    CLEAR_ALL_SCENE_BUILDING = 'CLEAR_ALL_SCENE_BUILDING',
    MARK_SCENE_TOUCHED_BY_AGENT = 'MARK_SCENE_TOUCHED_BY_AGENT',
    SET_SCENE_REVIEWING = 'SET_SCENE_REVIEWING',
    MARK_SCENE_BLURRED = 'MARK_SCENE_BLURRED',
    SKIP_REVIEW = 'SKIP_REVIEW',
    ENTER_CREATION_STAGE = 'ENTER_CREATION_STAGE',
    CLEAR_ALL_AGENT_ACTIVITY = 'CLEAR_ALL_AGENT_ACTIVITY',
}

// A 'review' (image_ask) clears a scene on its own; the others accumulate.
export type SceneFillKind = 'text' | 'media' | 'icon' | 'review';

export type SceneFillProgress = {
    needsText: boolean;
    needsMedia: boolean;
    needsIcon: boolean;
    text: boolean;
    media: boolean;
    icon: boolean;
    complete: boolean;
};

/**
 * - `building`  — created by the agent, content not all there yet.
 * - `reviewing` — being analyzed by a vision model (image_ask).
 * - `editing`   — touched by the agent this turn, content already in place.
 */
export type AgentActivityKind = 'idle' | 'building' | 'reviewing' | 'editing';

/**
 * The coarse phases of building a video from scratch, surfaced to the user so the
 * wait is legible rather than an unexplained spinner. Ordered: a stage only ever
 * moves forward within a turn.
 *
 * - `planning`  — a video skill has been loaded; the agent is deciding what to make.
 * - `building`  — the blank video exists; scenes and content are going in.
 * - `reviewing` — the finished video is being checked for mistakes.
 */
export type CreationStage = 'planning' | 'building' | 'reviewing';

export const CREATION_STAGE_ORDER: CreationStage[] = ['planning', 'building', 'reviewing'];
